<template>
  <v-expansion-panel>
    <v-expansion-panel-header v-slot="{ open }">
      <v-row no-gutters>
        <v-col cols="4" class="blue--text text--darken-1"> Bon de Livraison </v-col>
        <v-col cols="8" class="text--secondary">
          <v-fade-transition leave-absolute>
            <span v-if="open" key="0"> Editer le bon puis sauvegarder </span>
            <span v-else key="1">
              <div v-if="bonLivraison.account">
                {{ bonLivraison.account.name }}
              </div>
              <div v-if="bonLivraison.laverie">/ {{ bonLivraison.laverie.name }}</div>
            </span>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="bonLivraison.account"
            :items="accounts"
            :item-text="'name'"
            return-object
            label="Siège"
            @update:model-value="onAccountChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le compte siège
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.account" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="bonLivraison.laverie"
            :items="laveries"
            :item-text="'name'"
            return-object
            label="Laverie"
            @update:model-value="onChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la laverie
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.laverie && bonLivraison.laverie.address" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="1">
          <v-text-field
            name="numero"
            hint="Le numéro dans la rue"
            v-model="bonLivraison.laverie.address.numero"
            class="input-group--focused"
            label="Numero"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5">
          <v-text-field
            name="rue"
            hint="Le nom de la rue"
            v-model="bonLivraison.laverie.address.rue"
            class="input-group--focused"
            label="Rue"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Changez l'adresse si nécessaire
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.laverie && bonLivraison.laverie.address" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="1">
          <v-text-field
            name="codepostale"
            hint="Le code postale de la ville"
            v-model="bonLivraison.laverie.address.codepostale"
            class="input-group--focused"
            label="Code Postale"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5">
          <v-text-field
            name="ville"
            hint="Le nom de la ville"
            v-model="bonLivraison.laverie.address.ville"
            class="input-group--focused"
            label="Ville"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonLivraison.laverie" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-menu
            :close-on-content-click="true"
            v-model="dateMenu"
            transition="v-scale-transition"
            offset-y
            :nudge-left="40"
            max-width="290px"
          >
            <template v-slot:activator="{ props }">
              <v-text-field
                v-bind="props"
                label="Date de Livraison"
                v-model="bonLivraison.deliveryDate"
                prepend-icon="mdi-calendar"
                readonly
                @blur="onBlur"
              ></v-text-field>
            </template>
            <v-date-picker v-model="bonLivraison.deliveryDate" no-title scrollable>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la date de livraison
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveryDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-text-field
            name="etage"
            v-model="bonLivraison.accessibility.etage"
            class="input-group--focused"
            label="Etage"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="ascenseur"
            v-model="bonLivraison.accessibility.ascenseur"
            class="input-group--focused"
            label="Ascenseur"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="escalier"
            v-model="bonLivraison.accessibility.escalier"
            class="input-group--focused"
            label="Escalier"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Détaillez l'accessibilité
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveryDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-text-field
            name="codePorte"
            v-model="bonLivraison.laverie.codeAcces"
            class="input-group--focused"
            label="Code Porte"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="parkingPrive"
            v-model="bonLivraison.accessibility.parking"
            class="input-group--focused"
            label="Parking Privé"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="cle"
            v-model="bonLivraison.accessibility.key"
            class="input-group--focused"
            label="Clé"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveryDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="bonLivraison.deliveredBy"
            :items="users"
            :item-text="(item) => `${item.name} ${item.lastname}`"
            return-object
            label="Livré par"
            @update:model-value="onChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le livreur
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveredBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="gestionnaire"
            hint="Nom et prénom du gestionnaire"
            v-model="bonLivraison.laverie.gestionnaire"
            class="input-group--focused"
            label="Gestionnaire"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Changez le gestionnaire si nécessaire
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveredBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-text-field
            name="telephone"
            v-model="bonLivraison.laverie.telephoneAutre"
            class="input-group--focused"
            label="Téléphone"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            name="mobile"
            v-model="bonLivraison.laverie.telephonePrincipal"
            class="input-group--focused"
            label="Mobile"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveredBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="contactSecondPrenom"
            hint="Nom et prénom du contact secondaire"
            v-model="bonLivraison.contactSecond.name"
            class="input-group--focused"
            label="Autre contact"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Renseignez un contact secondaire
        </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveredBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="contactSecondFonction"
            hint="Fonction technique du contact secondaire"
            v-model="bonLivraison.contactSecond.fonction"
            class="input-group--focused"
            label="Fonction"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveredBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-text-field
            name="contactSecondTel"
            hint="Téléphone du contact secondaire"
            v-model="bonLivraison.contactSecond.telephone"
            class="input-group--focused"
            label="Téléphone"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            name="contactSecondMobile"
            hint="Mobile du contact secondaire"
            v-model="bonLivraison.contactSecond.mobile"
            class="input-group--focused"
            label="Mobile"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonLivraison.deliveredBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="bonLivraisonObservations"
            hint="Observations"
            v-model="bonLivraison.observations"
            class="input-group--focused"
            label="Observations"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Notez les observations en cas de non installation
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onCancel" text color="red"> Cancel </v-btn>
        <generate-doc-btn
          :filePath="bonLivraisonTemplatePath"
          :fileName="bonLivraisonFileName"
          :dataSet="bonLivraisonGen"
          >Save</generate-doc-btn
        >
      </v-card-actions>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import GenerateDocBtn from "@/components/GenerateDocBtn.vue";
import type { BonLivraison, BonLivraisonGen } from "@/types";
import { flattenBonLivraison } from "@/types";
import type { Accessibility } from "@/types";
import type { User } from "@/types";
import type { Account } from "@/types";
import type { Laverie } from "@/types";
import { getLaveriesByAccountId } from "@/utils/laverie-api";

// Props
interface Props {
  accounts: Account[];
  users: User[];
}

const props = defineProps<Props>();

// Reactive state
const dateMenu = ref(false);
const bonLivraison = ref<BonLivraison>({
  accessibility: {} as Accessibility,
  contactSecond: {} as User,
} as BonLivraison);
const bonLivraisonGen = ref<BonLivraisonGen>({} as BonLivraisonGen);
const laveries = ref<Laverie[]>([]);

// Computed properties
const bonLivraisonTemplatePath = computed(() => {
  return "templates/BonLivraisonTemplate.docx";
});

const bonLivraisonFileName = computed(() => {
  if (bonLivraison.value.laverie) {
    return "BonDeLivraison_".concat(bonLivraison.value.laverie.name);
  }
  return "BonDeLivraison";
});

// Methods
const onAccountChange = async (selectedAccount: Account) => {
  bonLivraison.value.account = selectedAccount;
  // Reset selected laverie
  bonLivraison.value.laverie = null;
  // Clear previous data
  laveries.value = [];
  await fetchLaveries(selectedAccount.id);
  // Regenerate document data
  bonLivraisonGen.value = flattenBonLivraison(bonLivraison.value);
};

const fetchLaveries = async (accountId: string) => {
  try {
    laveries.value = await getLaveriesByAccountId(accountId);
  } catch (error) {
    console.error("Error fetching laveries:", error);
    laveries.value = [];
  }
};

const onChange = () => {
  onBlur();
};

const onBlur = () => {
  bonLivraisonGen.value = flattenBonLivraison(bonLivraison.value);
};

const onCancel = () => {
  // TODO clear form
  bonLivraison.value = {
    accessibility: {} as Accessibility,
    contactSecond: {} as User,
  } as BonLivraison;
  bonLivraisonGen.value = {} as BonLivraisonGen;
  laveries.value = [];
};
</script>
